import { DictionaryAutocomplete, useListSource } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function useIpEntryModes() {
  return useListSource<DictionaryAutocomplete>({
    url: `${EvidenceApiUrl.IP_ENTRY}/modes/list`,
    method: 'GET',
  });
}
